module.exports = __webpack_public_path__ + "media/images/screenshots/roadmap-d147b5635c24aa8c686565932d21815f.png";